(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('telFormat', telFormat);

    telFormat.$inject = ['$parse'];
    function telFormat($parse) {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, element, attrs, ctrl) {
            function limit() {

                var limitV = element[0].value;
                limitV = limitV.replace(/[^0-9-+]/g, "");
                //console.log(limitV);
                element[0].value = limitV;
                $parse(attrs['ngModel']).assign(scope, limitV);
                // format();
                // alert(limitV);

            }
            scope.$watch(attrs.ngModel, function () {
                limit();
            })
        }

    }
})();